import { Link } from "react-router-dom";
import { PublicLayout } from "@/components/PublicLayout";
import { SectionHeading } from "@/components/shared";
import { Share2, UserCheck, Gift, ArrowRight } from "lucide-react";

export default function ReferralProgram() {
  const steps = [
    { icon: Share2, t: "Share your link", d: "Every account gets a unique referral code and link to share with your network." },
    { icon: UserCheck, t: "They join & deposit", d: "Your referral registers using your code and makes their first deposit." },
    { icon: Gift, t: "You earn a reward", d: "Once their first deposit is approved, a configurable percentage reward is credited to your balance." },
  ];
  return (
    <PublicLayout>
      <section className="max-w-5xl mx-auto px-4 sm:px-6 pt-16 pb-20">
        <SectionHeading center eyebrow="Referral Program" title="Grow the community, earn rewards"
          subtitle="AI TECHNOLOGY offers a single-level direct referral program. There are no multi-level trees — just direct, transparent rewards." />
        <div className="glass rounded-3xl p-8 lg:p-12 text-center mb-12">
          <div className="font-mono text-6xl font-bold text-gradient">5%</div>
          <p className="text-slate-400 mt-3">Default direct referral reward on a referred user's first approved deposit. This rate is configurable by the platform.</p>
        </div>
        <div className="grid sm:grid-cols-3 gap-6">
          {steps.map((s, i) => (
            <div key={s.t} className="glass glass-hover rounded-2xl p-7 text-center">
              <div className="w-14 h-14 rounded-2xl bg-cyan-500/10 border border-cyan-500/20 flex items-center justify-center mx-auto mb-5">
                <s.icon className="w-7 h-7 text-cyan-300" />
              </div>
              <h3 className="font-heading text-lg text-white mb-2">{s.t}</h3>
              <p className="text-sm text-slate-400">{s.d}</p>
            </div>
          ))}
        </div>
        <div className="text-center mt-12">
          <Link to="/signup" className="btn-glow inline-flex items-center gap-2 px-8 py-3.5 rounded-full font-semibold text-slate-950">
            Start Referring <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </PublicLayout>
  );
}
